import axios from 'axios';
import { getEnvConfig } from '../envConfig';

function getBaseUri(): string {
    return `${getEnvConfig().dpsUrl}`;
}

export default async function batchGetDps(ids: string[]): Promise<DesignPhysicalSpec.DesignPhysicalSpecDto[]> {
    const url = `https://${getBaseUri()}/api/v3/DesignPhysicalSpecs/BulkGet?requestor=${getEnvConfig().requestorParam}`;

    const response = await axios.post<DesignPhysicalSpec.DesignPhysicalSpecDto[]>(url, ids, {
        headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
        },
        validateStatus: () => true,
    });

    if (!response) {
        return [];
    }

    return response.status > 299 ? [] : response.data;
}
